import { get, post } from './request'

export let paginateAdmins = (path, success, failure) => {
  return get (
    `api${path}`, success, failure
  )
}

export let paginateTenants = (path, success, failure) => {
  return get (
    `api${path}`, success, failure
  )
}

export let paginateCustomers = (path, success, failure) => {
  return get (
    `api${path}`, success, failure
  )
}

export let paginateBookings = (path, success, failure) => {
  return get (
    `api${path}`, success, failure
  )
}

export let paginateDeposits = (path, success, failure) => {
  return get (
    `api${path}`, success, failure
  )
}

export let createAdmin = (user, success, failure) => post(
  `api/user/admin`, user, success, failure
)

export let createTenant = (user, success, failure) => post(
  `api/user/tenant`, user, success, failure
)

export let loadAdmin = (user, success, failure) => get(
  `api/user/admin/${user}`, success, failure
)

export let updateAdmin = (user, success, failure) => post(
  `api/user/admin/${user.id}`, user, success, failure
)

export let load = (user, success, failure) => get(
  `api/user/${user}/load`, success, failure
)

export let approve = (user, success, failure) => post(
  `api/user/${user.id}/approve`, user, success, failure
)

export let updateUser = (user, success, failure) => post(
  `api/user/${user.id}`, user, success, failure
)